import Lottie from 'lottie-react';
import noData from '../../assets/lottie/noData.json';
import { Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import { tokens } from '../../global/theme/tokens';

const NoDataAnimation = ({ size }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const prefersReducedMotion = useMediaQuery(
    '(prefers-reduced-motion: reduce)',
    { noSsr: true },
  );

  return (
    <Box
      className=" max-w-full "
      sx={{
        width: size || '240px',
        '& path': {
          fill: colors.text,
        },
      }}
    >
      {/* Plays once and then stops: a looping Lottie redraws the SVG on every
          frame for as long as the empty state is mounted. */}
      <Lottie
        className="w-full"
        animationData={noData}
        loop={false}
        autoplay={!prefersReducedMotion}
      />
    </Box>
  );
};

export default NoDataAnimation;
